export interface CompanyCreateEditInput {
  id?: string;
  name: string;
  slug: string;
  is_active: boolean;
  has_api: boolean;
  delivery_key: string;
}

export interface CompanyToggleInput {
  id: string;
  is_active?: boolean;
  has_api?: boolean;
}
export interface MethodToggleInput {
  id: string;
  is_active?: boolean;
  is_required?: boolean;
}

export interface MethodCreateEditInput {
  id?: string;
  name: string;
  method_code: string;
  shipping_fee: number; // keep as string if backend sends string
  min_cart_total: number;
  is_required: boolean;
  is_active: boolean;
  standard_fee: number;
}